module.exports = "<div class=\"pipeline-filter-breadcrumbs\" ng-if=\"dataset.length > 0\">\n    <span class=\"icon icon-delete-circle\" ng-click=\"removeFilter();\"></span>\n    <a id=\"link-filter-breadcrumbs\" ng-click=\"launchModal();\">\n        <span ng-repeat=\"data in dataset track by $index\">{{data}}<span ng-if=\"$index < dataset.length - 1\" class='pipeline-breadcrumbs'\\>|</span></span>\n    </a>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./src/app/pipeline/filterBreadcrumbs/filterBreadcrumbsTemplate.html
// module id = 256
// module chunks = 1